@if (type() === 'blue') {
<button
  class="num-button blue"
  [ngClass]="isDisabled() ? 'disabled' : ''"
  color="primary"
  [disabled]="isDisabled()"
  [matTooltip]="tooltip()"
  [matTooltipPosition]="'above'"
  [matTooltipShowDelay]="300"
>
  @if (icon()) {
  <fa-icon [icon]="icon()" size="lg" [fixedWidth]="true"></fa-icon>
  }
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>
} @if (type() === 'green') {
<button
  class="num-button green"
  color="primary"
  [ngClass]="isDisabled() ? 'disabled' : ''"
  [disabled]="isDisabled()"
  [matTooltip]="tooltip()"
  [matTooltipPosition]="'above'"
  [matTooltipShowDelay]="300"
>
  @if (icon()) {
  <fa-icon [icon]="icon()" size="lg" [fixedWidth]="true"></fa-icon>
  }
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>
} @if (type() === 'red') {
<button
  class="num-button red"
  color="primary"
  [ngClass]="isDisabled() ? 'disabled' : ''"
  [disabled]="isDisabled()"
  [matTooltip]="tooltip()"
  [matTooltipPosition]="'above'"
  [matTooltipShowDelay]="300"
>
  @if (icon()) {
  <fa-icon [icon]="icon()" size="lg" [fixedWidth]="true"></fa-icon>
  }
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>
} @if (type() === 'cancel') {
<button
  class="num-button cancel"
  [ngClass]="isDisabled() ? 'disabled' : ''"
  [disabled]="isDisabled()"
  [matTooltip]="tooltip()"
  [matTooltipPosition]="'above'"
  [matTooltipShowDelay]="300"
>
  @if (icon()) {
  <fa-icon [icon]="icon()" size="lg" [fixedWidth]="true"></fa-icon>
  }
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>
}

<ng-template #content><ng-content></ng-content></ng-template>
